<template>
    <span :class="classes">{{ label }}</span>
</template>

<script>
const TAG_VARIANT = ['neutral', 'add', 'remove', 'renew'];
export default {
    props: {
        label: {
            type: String,
            default: '',
        },
        variant: {
            type: String,
            default: 'neutral',
            validator(value) {
                return TAG_VARIANT.includes(value);
            },
        },
    },
    computed: {
        classes() {
            return [
                'typographies-paragraph-small-regular',
                'subscription-tag',
                `subscription-tag--${this.variant}`,
            ];
        },
    },
};
</script>

<style scoped lang="scss">
.subscription-tag {
    border-radius: 4px;
    padding: 0 var(--spacing-0);
    color: var(--colors-common-text-standard-on-color);
    &--neutral {
        border: 1px solid var(--colors-component-border-bloc-standard-default);
        background-color: var(--colors-component-background-information-tag-stroked);
        color: var(--colors-common-text-standard-default);
    }
    &--add {
        background-color: var(--colors-common-background-success-darker);
    }
    &--remove {
        background-color: var(--colors-common-background-alert-darker);
    }
    &--renew {
        background-color: var(--colors-common-background-primary-darker);
    }
}
</style>
